<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <input :model-modifiers="{ number: true }" v-money3="config" :id="id" :v-model.lazy="modelValue" :maxlength="maxlength" ref="input" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" :type="type" :value="modelValue" @input="onInput" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import { Money3Directive, unformat } from 'v-money3'

export default {
  directives: {
    money3: Money3Directive,
  },
  data() {
    return {
      config: {
        masked: false,
        prefix: 'R$ ',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: true,
        disabled: false,
        min: null,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
      }
    }
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `money-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'decimal',
    },
    error: String,
    label: String,
    modelValue: [String, Number],
    maxlength: {
      type: Number,
      default: 15,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    onInput(e) {
      let value = unformat(e.target.value, this.config);
      this.$emit('update:modelValue', value)
    },
  },
}
</script>
